module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.isLoading) ? _c(_vm.activeComponent, {
    tag: "component",
    attrs: {
      "profileId": _vm.profileId
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-459e1cb8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile.vue
// module id = 282
// module chunks = 1